export default {"src":"/_next/static/media/arrow_down.80a0e8c8.svg","height":13,"width":12,"blurWidth":0,"blurHeight":0};